module.exports = __webpack_public_path__ + "static/img/IMG_20241023_110419.477b44ab.jpg";